import React, { useState } from 'react';
import { Box, Checkbox, Typography } from '@mui/material';

const CustomCheckbox = ({ checked, onChange, disabled }) => (
  <Checkbox
    checked={checked}
    onChange={onChange}
    disabled={disabled}
    icon={
      <Box
        sx={{
          width: 24,
          height: 24,
          borderRadius: '4px',
          border: '1px solid #D0D5DD',
          backgroundColor: '#E5E8EB',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          opacity: disabled ? 0.5 : 1,
        }}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path
            d="M20 6L9 17L4 12"
            stroke="white"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </Box>
    }
    checkedIcon={
      <Box
        sx={{
          width: 24,
          height: 24,
          borderRadius: '4px',
          backgroundColor: '#1976d2',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          opacity: disabled ? 0.5 : 1,
        }}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path
            d="M20 6L9 17L4 12"
            stroke="white"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </Box>
    }
  />
);

const CheckBoxSec = ({ projects = [] }) => {
  const [selectedValues, setSelectedValues] = useState([]);

  const handleCheckboxChange = (projectName) => {
    setSelectedValues((prev) =>
      prev.includes(projectName)
        ? prev.filter((name) => name !== projectName)
        : [...prev, projectName]
    );
  };

  return (
    <Box>
      {projects.map((project, index) => {
        const isDisabled = project.name === false;
        return (
          <Box key={index} display="flex" alignItems="center"  sx={{ textWrap: 'nowrap' ,  '& .MuiButtonBase-root': {p: 0,},}}>
            <CustomCheckbox
              checked={selectedValues.includes(project.name)}
              onChange={() => handleCheckboxChange(project.name)}
              disabled={isDisabled}
            />
            <Typography sx={{ marginLeft: '7px' ,  fontSize:{xl: '16px' , lg: '16px' , md: '14px' , sm: '14px' , xs: '14px'}, fontWeight:'600', fontFamily:'Manrope', color: isDisabled ? '#999' : 'inherit' }}>
              {isDisabled ? false : project.name}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default CheckBoxSec;
